import ReportHeader from './ReportHeader'

export default ReportHeader
